<div class="modal-body">
  <div class="panel-item">
    <label class="panel-label">Телефон</label>
    <input readonly prefix="+7" mask=" (000) 000 00 00" type="text" class="panel-input" [(ngModel)]="login" placeholder="Введите ваш номер">
  </div>
  <div class="panel-action-btns">
    <app-button
      [buttonClass]="'big-gray-light'"
      [text]="'Назад'"
      [styleInline]="{ 'height': '100%' }"
      (buttonClick)="stepBack()"
    ></app-button>
    <app-button
      [buttonClass]="'big-purple-gradient'"
      [text]="'Получить код'"
      [disabled]="isSendCode"
      [styleInline]="{ 'height': '100%' }"
      (buttonClick)="sendCode()"
    ></app-button>
  </div>
</div>


